import { fadeAnime, fadeUpGroup, delayScrollAnime } from './modules/animation.js';
import { header } from './modules/header.js';
import { toTop } from './modules/to-top.js';

window.addEventListener('load', () => {
    header();
    toTop();
    fadeAnime();
    fadeUpGroup();
    delayScrollAnime();
});

window.addEventListener('scroll', () => {
    fadeAnime();
    fadeUpGroup();
    delayScrollAnime();
});
